import { MapTemplate, MapType } from 'types';

export const defaultMapTemplate = MapTemplate.littlePigs;
export const defaultMapType = MapType.Static;

export const SVG_VIEWBOX_WIDTH = 1522.8;

export const minHeight = 768;
